// extracted by mini-css-extract-plugin
export var cartContainer = "_mn-4";
export var gray = "_mn-1";
export var itemContainer = "_mn-2";
export var itemDetails = "_mn-3";
export var strong = "_mn-0";